module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-e8e6d378d2d9d78b7ccb5e08bbed0f37.webp";